export default __webpack_public_path__ + "static/media/logo.f13ffdb8.png";